/** Pickers list people most-recently-assigned first, then by name (owner rule, Sep 2026). */
export function byRecentAssignment(a: any, b: any): number {
  const da = String(a?.last_assigned_date || '');
  const db = String(b?.last_assigned_date || '');
  if (da !== db) return da < db ? 1 : -1;   // newest date first, never-assigned last
  return String(a?.name || '').localeCompare(String(b?.name || ''));
}

export function fmtLastWorked(iso?: string | null): string {
  if (!iso) return 'never';
  return new Date(String(iso).slice(0, 10) + 'T12:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
